import {
	Component,
	Input,
	OnInit,
	SimpleChanges,
	ChangeDetectionStrategy,
} from "@angular/core"
import { PermsService } from "@app/services/perms.service"
import { StoreService } from "@app/services/store.service"
import { ModalService } from "@app/services/modal.service"
import { COMMON_IMPORTS } from "../common-imports"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { CcInsertPatientTemplate } from "@app/cc-checkboxes/cc-checkboxes.component"
import { PatientDetailsFieldsManageComponent } from "@app/patient-details-fields-manage/patient-details-fields-manage.component"
import { PatientUnifyComponent } from "@app/patient-unify/patient-unify.component"
import {
	ImportPatientsComponent,
	ImportTagsComponent,
	ImportFollowupsComponent,
} from "@app/imports/import-common.component"
import { CcParamsUserDetailsComponent } from "@app/cc-params-user-details/cc-params-user-details.component"
import { CcParamsSubUserComponent } from "@app/cc-params-sub-user/cc-params-sub-user.component"
import { UserComponent } from "@app/user/user.component"
import { CcParamsAccountantComponent } from "@app/cc-params-accountant/cc-params-accountant.component"
import { CcParamsCreditClearanceComponent } from "@app/cc-params-credit-clearance/cc-params-credit-clearance.component"
import { ItaGetAuthComponent } from "@app/ita-get-auth/ita-get-auth.component"
import { TestManageComponent } from "@app/test-manage/test-manage.component"
import { CcParamsPublicTestsComponent } from "@app/cc-params-public-tests/cc-params-public-tests.component"
import { CcParamsHolidayComponent } from "@app/cc-params-holiday/cc-params-holiday.component"
import { Activity } from "@app/activity/activity"
import { InviteTextApprovalComponent } from "@app/invite-texts-approval/invite-texts-approval.component"
import { PaymentFormComponent } from "@app/payment-form/payment-form.component"
import { ChangePasswordComponent } from "@app/change-password/change-password.component"
import { CcParamsUserDetailsWebsiteComponent } from "@app/cc-params-user-details-website/cc-params-user-details-website.component"
import {
	GenTableComponent,
	GenTablePaginationComponent,
} from "@app/gen-table/gen-table.component"
import { InviteTextsComponent } from "@app/invite-texts/invite-texts.component"
@Component({
	selector: "app-cc-sections",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		CcInsertPatientTemplate,
		PatientDetailsFieldsManageComponent,
		PatientUnifyComponent,
		ImportPatientsComponent,
		ImportFollowupsComponent,
		CcParamsUserDetailsComponent,
		CcParamsSubUserComponent,
		UserComponent,
		ImportTagsComponent,
		CcParamsAccountantComponent,
		CcParamsCreditClearanceComponent,
		ItaGetAuthComponent,
		TestManageComponent,
		CcParamsPublicTestsComponent,
		CcParamsHolidayComponent,
		Activity,
		InviteTextApprovalComponent,
		PaymentFormComponent,
		ChangePasswordComponent,
		CcParamsUserDetailsWebsiteComponent,
		GenTablePaginationComponent,
		GenTableComponent,
		InviteTextsComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./cc-sections.component.html",
})
export class CcSectionsComponent {
	@Input() name: string = ""
	@Input() section: string = ""

	sections: any[] = []

	areaSections = {
		user_area: [
			{
				tableName: "affiliated_users",
				color: "#eee7b6",
			},
		],
		patients: [
			{
				tableName: "patients",
				color: "#d0a747",
			},
			{ tableName: "groups", color: "#f7b2c2" },
			{ tableName: "inquirers", color: "#ac85bc" },
			// { tableName: "patienttypes", color: "#E2F0CB"},
			{
				tableName: "cc-insert-patient-templates",
				title: "select_fields",
				color: "#699fca",
			},
			{ tableName: "patientfields", color: "#c8e7d9" },
			{
				tableName: "patient-details-fields-manage",
				title: "patient_details_fields",
				color: "#7c9c6b",
			},
			{ tableName: "referers", color: "#E3ED00" },
			// { tableName: "inquiry_statuses", color: "#cafde0"},
			{
				tableName: "patient_unification",
				color: "#c4ac78",
			},
			{
				tableName: "import-patients",
				title: "import_patients",
				color: "#c4abb4",
			},
			{
				tableName: "import-followups",
				title: "import_followups",
				color: "#92afcc",
			},
			{ tableName: "contactway_list", title: "emails", color: "#93cdce" },
		],
		multiuser: [
			{
				tableName: "sub_users",
				title: "sub_users_dashboard",
				color: "#a7d6a3",
				isOpen: true,
			},
			{
				tableName: "cc-params-user-details",
				title: "multiuserdetails",
				color: "#c0dc8f",
			},
			{
				tableName: "sub-user",
				title: "userdetails",
				color: "#c8c9a9",
			},

			{
				tableName: "user",
				title: "my_account",
				color: "#c2b39c",
			},

			{ tableName: "clinic_roles", title: "roles", color: "#fee4cd" },
			{ tableName: "locations", color: "#efe6e3" },
			{ tableName: "tags", color: "#f4817e" },
			{
				tableName: "import-tags",
				title: "import_tags",
				color: "#cd92c1",
			},
			{ tableName: "meetingtypes", color: "#9676b5" },
			{ tableName: "tarifs", title: "tarif", color: "#b4d9f3" },

			{
				tableName: "sub_user_groups",
				color: "#a4d0d1",
			},
			{ tableName: "partners", color: "#a0c2b4" },
		],
		taxes: [
			// { tableName: "financial", title: "financial",color: "#FFB7B2", isOpen: true, isTable:false },
			{
				tableName: "ita-get-auth",
				title: "get_israel_invoice",
				color: "#519d9f",
			},
			{ tableName: "taxes", color: "#bab974" },
			{ tableName: "payors", color: "#f2d440" },
			{
				tableName: "accountant",
				color: "#baa88d",
			},
			{ tableName: "expensetypes", color: "#fbba89" },
			{ tableName: "suppliers", color: "#c5a6a2" },
			// { tableName: "hashav", title: "hashav", color: "#FFDA11" },

			{
				tableName: "ownerbankaccounts",
				color: "#a694c7",
			},
			{
				tableName: "credit-clearance",
				title: "credit_clearance",
				color: "#32a4d5",
			},
		],
		info_tables: [
			{ tableName: "medics", color: "#519d9f", isPagi: true },
			{ tableName: "nondrugs", color: "#c9e6d3" },
			{ tableName: "labtests", color: "#9bc09a" },
			{
				tableName: "diagps",
				title: "diagnosis",
				color: "#7e975d",
				isPagi: true,
			},
		],
		// "document-and-quest":[
		tests: [
			{
				tableName: "tests",
				color: "#cecac5",
			},
			{
				tableName: "public_tests",
				color: "#d0c491",
			},
			// { tableName: "documenttemplates", color: "#FFB7B2" },
		],
		journal: [
			// { tableName: "calendar_config", color: "#FFB7B2", isOpen: true, isTable:false },
			{ tableName: "meetingtypes", color: "#fecb8b" },
			{ tableName: "followuptypes", color: "#c8ada0" },
			{
				tableName: "holiday",
				color: "#f79f99",
			},
		],
		"home-super-admin": [
			{ tableName: "users", color: "#a3c6df" },
			{ tableName: "announces", color: "#98a2aa" },
			{
				tableName: "activity",
				color: "#6d9f71",
			},
			{
				tableName: "invite_texts_approval",
				color: "#6d9f71",
			},
		],
		user_payments: [
			// { tableName: "financial",color: "#FFB7B2", isOpen: true, isTable:false },
			{
				tableName: "payment",
				color: "#cbdf7d",
			},
			{
				tableName: "admininvoices",
				color: "#bcb0b3",
			},

			{
				tableName: "affiliated_users",
				color: "#ffd100",
			},
		],
		automation: [
			{
				tableName: "accountant",
				color: "#efd795",
			},
			{ tableName: "patients_sms", color: "#d3aa73" },
			{ tableName: "invite_texts", color: "#ac85bc" },
			{ tableName: "invite_templates", color: "#699fca" },
		],
		security: [
			{
				tableName: "change_password",
				color: "#eaa380",
			},
		],
		self_coordination: [
			{
				tableName: "user-details-website",
				title: "userdetails_website",
				color: "#f4817e",
			},
		],
	}

	constructor(
		public store: StoreService,
		public permsService: PermsService,
		public modalService: ModalService
	) {}

	ngOnChanges(changes: SimpleChanges) {
		//if person changed (ex: contact) - send to load function
		if (changes.section) {
			this.sections = this.areaSections[this.section] || []
		}
	}

	openSection(section: any) {
		const curIsClosed = !section.isOpen
		this.sections.forEach((section) => (section.isOpen = false))
		if (curIsClosed) {
			section.isOpen = true
		}
	}
}
